<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="homeBoxa">
		<van-radio-group v-model="roomType">
			<van-radio name="1">单间</van-radio>
			<van-radio name="2">标间</van-radio>
		</van-radio-group>
		<van-radio-group v-model="guestGender">
			<van-radio name="1">男</van-radio>
			<van-radio name="2">女</van-radio>
		</van-radio-group>
		</div>
		<van-cell-group>
			<van-field v-model="guestName"  label="姓名" placeholder="入住人姓名" />
		</van-cell-group>
		<van-popup v-model="hotelStartStatus"  position="bottom">
			<van-datetime-picker
					v-model="hotelStart"
					type="date"
					@confirm="confirmDate('hotelStart')"
					 :min-date="minDate"
			/>
		</van-popup>
		<van-cell-group>
			<van-field @click="hotelStartStatus=true" label="入住时间" v-model = "hotelRangeStart" placeholder="入住开始时间" />
		</van-cell-group>
		<van-popup v-model="hotelEndStatus" position="bottom">
			<van-datetime-picker
					v-model="hotelEnd"
					type="date"
					@confirm="confirmDate('hotelEnd')"
					 :min-date="minDate"
			/>
		</van-popup>
		<van-cell-group>
			<van-field @click="hotelEndStatus=true"  label="离开时间" v-model = "hotelRangeEnd" placeholder="入住结束时间" />
		</van-cell-group>
		<div class="vanButton">
		 <van-button type="primary" @click="submitHotel">提交</van-button>
	    </div>
	</div>
</template>
<script>
	import { Toast ,Button ,RadioGroup, Radio,Field ,CellGroup,DatetimePicker ,Popup} from "vant";
	import {hotelSave} from "@/api/dictionary";
	import {mapState} from "vuex";
	import {getSessionStore} from "@/utils/sessionStorage.js"
	import vHead from "../../components/Subhead.vue";
	export default {
		data() {
			return {
				roomType:"",//房源选择
				guestName:"",//入住人姓名
				guestGender:"",//入住人性别
				hotelRangeStart:"",//入住时间
				hotelRangeEnd:"",//入住时间
				hotelEnd:new Date(),//当前时间
				hotelStart:new Date(),//当前时间
				hotelStartStatus:false,//酒店开始时间选择器
				hotelEndStatus:false,//酒店结束时间选择器
				title:"选择宾馆",
				minDate: new Date(),
			};
		},
		components: {
			vHead,
			[Toast .name]: Toast ,
			[Button.name]: Button,
			[RadioGroup.name]: RadioGroup,
			[Radio.name]: Radio,
			[Field .name]: Field ,
			[CellGroup .name]: CellGroup ,
			[DatetimePicker  .name]: DatetimePicker  ,
			[Popup  .name]: Popup  ,
		},
		methods: {
			submitHotel() {
				let params = {
					meetingId: this.meetingId,
					memberId: getSessionStore("memberId"),
					hotelId: this.hotelId,
					roomType: this.roomType,
					shareRoom: "0",
					guestName: this.guestName,
					guestGender: this.guestGender,
					checkInTime: this.timeFormate(this.hotelRangeStart) + ' 00:00:00',
					checkOutTime: this.timeFormate(this.hotelRangeEnd) + ' 00:00:00'
				};
				if (!this.guestName ) {
					Toast.fail("请输入入住人姓名");
					return;
				}
				if (!this.guestGender) {
					Toast.fail("请选择性别");
					return;
				}
				if (!this.roomType) {
					Toast.fail("请选择房型");
					return;
				}
				if (!this.hotelRangeStart || !this.hotelRangeEnd) {
					Toast.fail("请输入入住时间");
					return;
				}

				hotelSave(params).then(res => {
					if (res.success) {
						Toast.success("预订成功");
						this.$router.push({ name: 'EnrolledMeeting' });
					} else {
						Toast.fail(res.message);
					}
				});
			},
			timeFormate(timeStamp) {
				let year = new Date(timeStamp).getFullYear();
				let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
				let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
				// let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
				// let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
				// let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
				return year + "-" + month + "-" + date;
			},
			confirmDate(field){//确定
				if(field=="hotelStart"){
					let date = this.timeFormate(this.hotelStart);
					this.hotelRangeStart = date;
				}else {
					let date = this.timeFormate(this.hotelEnd);
					this.hotelRangeEnd = date;
				}
				this.hotelStartStatus = false;
				this.hotelEndStatus = false;
			}
		},
		computed:{  
			meetingId(){
				return this.$route.query&&this.$route.query.meetingId;
			},
			hotelId(){
				return this.$route.query&&this.$route.query.id;
			},
			...mapState(["userInfo"])
		},
	};
</script>

<style  lang="less" scoped>
	.means{
		padding:20px 13px 15px 13px; background:url(../../assets/images/hy_bg.jpg); background-size: 100%; overflow:hidden;
		.van-button{ float: right; background: #fff; color: #378be1; border:none; line-height: 26px; height: 35px;  margin-top: 8px;}
	}
	.portrait{ width:15%; float:left;}
	.means_name{float:left; font-size:14px; color:#fff; margin-top:5px;line-height:24px; margin-left:10px;}
	.more{ float:right; margin-top:25px; color:#fff;}
	.means_top{ overflow: hidden; }
	.mean_bottom{ font-size: 14px; color: #fff;  margin-top: 15px;
		.left_c{ float: left; line-height: 26px;}
	}

	.menu { padding:15px 0; border-bottom: #f2f2f2 8px solid;
		.van-col{ text-align: center;
			img{ display: block; width: 45%; margin:0 auto; }
			span{ font-size: 13px;  margin-top:10px; display:block;}
		}
	}
	.meeting_box{
		padding:15px;
		img{ width: 100%; max-height: 5.2rem}
		li{border-bottom:#dfdfdf solid 1px; padding-bottom: 15px; position: relative; margin-bottom: 15px;}
		.van-button{ float: right; background: #378be1; color: #fff; border:none; line-height: 26px; height: 30px;  margin-top: 8px;
			position: absolute; bottom:15px; right:0px;}

	}
	.fonts{ font-size: 13px; line-height: 24px; margin-top: 10px;}
	/deep/.van-nav-bar .van-icon{
		color: #fff;
	}
.homeBoxa { overflow: hidden; padding: 20px 15px;}
.homeBoxa /deep/.van-radio{ float: left; margin:0 15px;}
.vanButton{ text-align: center; margin: 35px 0;}
.vanButton .van-button{ width: 90%; }
/deep/.van-cell-group{ margin-top: -1px; }
/deep/.van-ellipsis{ display: inline-block; line-height: 50px;color: #dfdfdf;}
/deep/.van-nav-bar__text{color: #dfdfdf;}
</style>